/**
 * * Interfaces/types/constants for blocks-related information.
 */

export const CONTAINER_BLOCK_TYPES = {
  CANVAS: 'canvas',
  LAYOUT: 'layout',
  SECTION: 'section',
  STANDALONE: 'standalone'
};
export const CONTENT_BLOCK_TYPES = {
  ACTIVITY_FEED: 'activity-feed',
  CUSTOM_EMBEDDED_CODE: 'custom-embedded-code',
  CUSTOM_CODE: 'custom-code',
  DONATION: 'donation',
  FAQ: 'faq',
  FOOTER: 'footer',
  HEADER: 'header',
  HEADING: 'heading',
  IMAGE: 'image',
  IMPACT: 'impact',
  LINK_BUTTON: 'link-button',
  PARAGRAPH: 'paragraph',
  PROGRESS_METRICS: 'progress-metrics',
  SHARE_BUTTON: 'share-button',
  SOCIAL_LINKS: 'social-links',
  START_FUNDRAISER_BUTTON: 'start-fundraiser-button',
  TITLE: 'title',
  TRANSACTION_DETAILS: 'transaction-details',
  VIDEO: 'video'
};
export const BLOCK_TYPES = {
  ...CONTAINER_BLOCK_TYPES,
  ...CONTENT_BLOCK_TYPES
};

/**
 * In Rich Mahogany (and Whammy!), shared blocks are page blocks that are the same across pages,
 * and are not children of the Canvas block.
 */

/**
 * data-* props/attributes
 */

/**
 * Represents the currently logged-in member.
 * See Whammy's <Block/> component for additional information.
 */